export default class ProductType {
  static get AllProducts() {
    return this.getInstance('AllProducts');
  }

  static get Custom() {
    return this.getInstance('custom');
  }

  static get Communities() {
    return this.getInstance('communities');
  }

  static get Homes() {
    return this.getInstance('homes');
  }

  static get BuildOnYourLot() {
    return this.getInstance('boyl');
  }

  static fromKey(key) {
    const productTypeMap = {
      allProducts: ProductType.AllProducts,
      custom: ProductType.Custom,
      communities: ProductType.Communities,
      homes: ProductType.Homes,
      boyl: ProductType.BuildOnYourLot,
    };

    return productTypeMap[key];
  }

  static getInstance(key) {
    if (!this.instances[key]) {
      this.instances[key] = new ProductType(key);
    }
    return this.instances[key];
  }

  constructor(name) {
    this.name = name;
  }

  toString() {
    return `${this.name}`;
  }
}

Object.defineProperty(ProductType, 'instances', { value: {} });